import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PopupLoaderModule } from "@app/shared";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { DropdownModule } from "primeng/dropdown";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { MaterialModule } from "../../../../../shared/material.module";
import { NgxCountdownModule } from "../ngx-countdown/ngx-countdown.module";
import { ConnectsAiComponent } from "./connects-ai.component";
@NgModule({
  declarations: [ConnectsAiComponent],
  imports: [
    MaterialModule, CommonModule, FormsModule, ReactiveFormsModule, NgxCountdownModule, InfiniteScrollModule, DropdownModule,
    PopupLoaderModule, ScrollPanelModule
  ],
  exports: [ConnectsAiComponent],
})
export class ConnectsAiModule { }
